import BaseInfoBox from "../BaseInfoBox";
import HTPThirdPart from "../HTPThirdPart";


export default class HTPAllSymbolsInfo extends BaseInfoBox {
  private HTPSecondPart = HTPThirdPart.getInstance();
  constructor() {
    super();
    this._addCoord();
    this.addBg(260, 170, 0x8e3fb8, 0x9e4fc8);
    this.addText("ALL SYMBOLS WORTH THE SAME, CHECK THE PRIZE CHART", 85, 240);
    this.addToCon();
    this.scale.set(this.startScale);
    this.visible = false;
  }
  _addCoord(){
    let x = 450;
    let y = -120;
    if (this.isVertical) {
      x = 150;
      y = 400
    }
    this.addCoord(x, y);
  }
  addToCon() {
    this.HTPSecondPart.addChild(this);
  }
}